import AgencyHelper, { AgencyConstants } from "features/Agency/agencyHelper";
import AgencySaleCreateTechnicalAcceptanceView from "features/Agency/components/AgencySaleCreateTechnicalAcceptanceView";
import AgencySaleDialogView from "features/Agency/components/AgencySaleDialogView";
import { AppCustomDialogHelper } from "general/components/AppDialogCustom";
import KTLabel, { KTLabelSize } from "general/components/OtherKeenComponents/KTLabel";
import KTTable from "general/components/OtherKeenComponents/KTTable";
import tableStyle from "general/components/OtherKeenComponents/KTTable/tableStyle";
import EmptyView from "general/components/Others/EmptyView";
import FileUploadView from "general/components/quybka/Uploads/FileUploadView";
import VITableRowDropDown from "general/components/VITableRowDropDown";
import AppColors from "general/constants/AppColors";
import AppResource from "general/constants/AppResource";
import ToastHelper from "general/helpers/ToastHelper";
import UIHelper from "general/helpers/UIHelper";
import Utils from "general/utils/Utils";
import PropTypes from "prop-types";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";

ChargeStationAcceptanceListView.propTypes = {
    acceptanceReportList: PropTypes.array,
    chargeStationDetail: PropTypes.object,
    onRefresh: PropTypes.func,
};

function ChargeStationAcceptanceListView({
    acceptanceReportList = [],
    chargeStationDetail = null,
    onRefresh,
}) {
    // MARK: ---- PROPERTIES ----
    const { user } = useSelector((state) => state.auth);
    const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
    const isAgency = user?.role === 'AGENCY';
    const isAdminMain = (user?.role === 'ADMIN' || user?.role === 'OPERATOR') && !Utils.isValid(user?.position);
    const isAdminMaintainer = (user?.role === 'ADMIN' || user?.role === 'OPERATOR') && (['INFRA_ENGINEERING_MANAGER', 'INFRA_ENGINEER'].includes(user?.position));
    const [dialogSize, setDialogSize] = useState('xl');
    const [creatingAcceptanceReport, setCreatingAcceptanceReport] = useState(false);

    const handleViewFiles = (files) => {
        AppCustomDialogHelper.show(
            'Tệp đính kèm',
            <FileUploadView
                pathList={files}
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
            />,
            'md',
            false,
            true
        );
    };

    const acceptanceReportColumns = useMemo(() => {
        return [
            {
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
                    >
                        Mã biên bản
                    </span>
                ),
                selector: (row) => (
                    <span
                        className="cursor-pointer hover-opacity-60"
                        onClick={() => {
                            if (Utils.isValid(row?.document)) {
                                Utils.openInNewTab(Utils.getFullUrl(row?.document));
                            }
                        }}
                    >
                        {row?.acceptanceCode ?? row?.acceptanceId}
                    </span>
                ),
                minWidth: '180px',
                style: tableStyle.columns.link,
            },
            {
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
                    >
                        Mẫu biên bản
                    </span>
                ),
                selector: (row) => AgencyHelper.Utils.getAcceptanceRoleName(row?.acceptanceType),
                width: '220px',
                style: tableStyle.columns.normal,
            },
            {
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
                    >
                        Loại biên bản
                    </span>
                ),
                selector: (row) =>
                    _.find(AgencyHelper.Data.acceptanceTypeOptions, (item) => item.value === row?.documentType)
                        ?.name,
                width: '180px',
                style: tableStyle.columns.normal,
            },
            {
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
                    >
                        Số biên bản
                    </span>
                ),
                selector: (row) => row?.number,
                minWidth: '180px',
                style: tableStyle.columns.normal,
            },
            {
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
                    >
                        Ngày biên bản
                    </span>
                ),
                selector: (row) => Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY'),
                minWidth: '120px',
                style: tableStyle.columns.normal,
            },
            {
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
                    >
                        Ngày hiệu lực
                    </span>
                ),
                selector: (row) => Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY'),
                minWidth: '120px',
                style: tableStyle.columns.normal,
            },
            {
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
                    >
                        Trạng thái
                    </span>
                ),
                selector: (row) => (
                    <KTLabel
                        text={AgencyHelper.Utils.getContractStatusName(row?.status)}
                        isInline={true}
                        size={KTLabelSize.medium}
                        additionalClassName={`label-light-${AgencyHelper.Utils.getContractStatusColor(
                            row?.status
                        )}`}
                        additionalDescription={row?.cancelingReason}
                    />
                ),
                minWidth: '160px',
                style: tableStyle.columns.normal,
            },
            {
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
                    >
                        Tệp đính kèm
                    </span>
                ),
                selector: (row) => {
                    return row?.attachedFiles?.length > 0 ? (
                        <span
                            className="hover-opacity-60 cursor-pointer"
                            onClick={() => {
                                handleViewFiles(row?.attachedFiles);
                            }}
                        >
                            {`Xem chi tiết (${row?.attachedFiles?.length})`}
                        </span>
                    ) : (
                        <></>
                    );
                },
                minWidth: '140px',
                style: tableStyle.columns.link,
            },
            {
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
                    >
                        Ngày tạo
                    </span>
                ),
                selector: (row) => Utils.formatDateTimeToString(row?.createdAt),
                minWidth: '180px',
                style: tableStyle.columns.normal,
            },
            {
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
                    >
                        Thao tác
                    </span>
                ),
                maxWidth: '140px',
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                center: false,
                cell: (row) => {
                    return UIHelper.buildMoreActionsButton(buildMoreActionsAcceptance(row), true);
                },
            },
        ];
    }, [user]);

    const technicalAcceptance = useMemo(() => {
        if (!chargeStationDetail) return null;
        return chargeStationDetail?.acceptanceReports?.find(
            (acceptance) => acceptance?.acceptanceType === AgencyConstants.AcceptanceRole.TECHNICAL
        ) || null;
    }, [chargeStationDetail]);

    // MARK: ---- FUNCTIONS ----
    const createEditTechnicalAction = (row) => ({
        text: 'Chỉnh sửa',
        iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
        click: () => {
            AppCustomDialogHelper.show(
                'Chỉnh sửa biên bản',
                <AgencySaleCreateTechnicalAcceptanceView
                    acceptanceDetail={row}
                    chargeStationDetail={chargeStationDetail}
                    onCancel={AppCustomDialogHelper.hide}
                    onConfirm={async (param) => {
                        try {
                            let acceptanceReportParam = param;
                            if (param?.documentType === AgencyConstants.AcceptanceType.PAPER) {
                                acceptanceReportParam = _.omit(acceptanceReportParam, ['attachedFiles']);
                            }

                            const result = await AgencyHelper.API.requestUpdateAcceptanceReport(
                                row?.acceptanceId,
                                acceptanceReportParam
                            );

                            if (result && _.isBoolean(result)) {
                                ToastHelper.showSuccess('Cập nhật biên bản nghiệm thu thành công');
                                AppCustomDialogHelper.hide();
                                if (onRefresh) {
                                    onRefresh();
                                }
                            } else {
                                ToastHelper.showError(result || 'Cập nhật biên bản nghiệm thu thất bại');
                            }
                        } catch {
                            ToastHelper.showError('Có lỗi xảy ra khi cập nhật biên bản nghiệm thu');
                        }
                        return false;
                    }}
                />,
                'xl',
                false,
                true
            );
        },
    });

    const createCancelAction = (row) => ({
        text: 'Hủy biên bản',
        iconElement: <i className="fa-regular fa-circle-xmark" style={{ fontSize: '1.1rem' }} />,
        click: () => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogError} />}
                    title="Hủy biên bản"
                    contentEl={
                        <>
                            Nhập lý do hủy biên bản{' '}
                            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                                {row?.number}
                            </span>
                        </>
                    }
                    onCancel={AppCustomDialogHelper.hide}
                    onConfirm={async () => {
                        const result = await AgencyHelper.API.requestUpdateAcceptanceReport(
                            row?.acceptanceId,
                            { status: AgencyConstants.AcceptanceStatus.CANCELLED }
                        );
                        if (result && _.isBoolean(result)) {
                            ToastHelper.showSuccess('Hủy biên bản thành công');
                            AppCustomDialogHelper.hide();
                            if (onRefresh) {
                                onRefresh();
                            }
                        } else {
                            ToastHelper.showError(result || 'Hủy biên bản thất bại');
                        }
                    }}
                    confirmButtonRed
                />,
                'md',
                false,
                true
            );
        },
    });

    const createDeleteAction = (row) => ({
        text: 'Xoá biên bản',
        iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
        click: () => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
                    title="Xoá biên bản"
                    contentEl={
                        <>
                            Bạn có chắc muốn xoá biên bản:{' '}
                            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                                {row?.number}
                            </span>
                            ?
                        </>
                    }
                    onCancel={AppCustomDialogHelper.hide}
                    onConfirm={async () => {
                        AppCustomDialogHelper.hide();
                        const result = await AgencyHelper.API.requestDeleteAcceptanceReport(row?.acceptanceId);
                        if (result && _.isBoolean(result)) {
                            ToastHelper.showSuccess('Xoá biên bản thành công');
                            if (onRefresh) {
                                onRefresh();
                            }
                        } else {
                            ToastHelper.showError(result || 'Xoá biên bản thất bại');
                        }
                    }}
                    confirmButtonRed
                />,
                'md',
                false,
                true
            );
        },
    });

    const handleSignAcceptance = (row) => {
        AppCustomDialogHelper.show(
            '',
            <AgencySaleDialogView
                iconEl={<img src={AppResource.images.dialogIcons.dialogSignContract} />}
                title="Ký biên bản"
                contentEl={
                    <>
                        Bạn muốn ký biên bản:{' '}
                        <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                            {row?.number}
                        </span>
                        ?
                    </>
                }
                showInput={true}
                inputLabel={['Định danh chữ ký số (UUID)', 'Nhập mật khẩu']}
                inputType={['text', 'password']}
                showAdditionalInfo={!isAdmin}
                additionalInfo={
                    <div
                        className="d-flex gap-3 p-3 align-items-center"
                        style={{
                            border: `1px dashed ${AppColors.danger}`,
                            backgroundColor: '#FFF6F6',
                        }}
                    >
                        <div className="w-32px h-32px rounded-circle bg-danger-o-20 d-flex align-items-center justify-content-center">
                            <i className="fas fa-signature" style={{ color: AppColors.danger }} />
                        </div>
                        <div className="d-flex flex-column">
                            <div style={UIHelper.buildFontStyle('700', '20px', AppColors.danger)}>
                                Bạn chưa có chữ ký số?
                            </div>
                            <div>
                                <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
                                    Vui lòng tạo chữ ký số{' '}
                                </span>
                                <a
                                    href={'#'}
                                    target={'_blank'}
                                    style={UIHelper.buildFontStyle('700', '14px', AppColors.danger)}
                                >
                                    tại đây
                                </a>
                            </div>
                        </div>
                    </div>
                }
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
                onConfirm={async (values) => {
                    const [hsmAgreementUUID, hsmPassword] = values;
                    AppCustomDialogHelper.hide();
                    let acceptanceReport = null;
                    if (isAdmin) {
                        if (row?.acceptanceType === AgencyConstants.AcceptanceRole.TECHNICAL) {
                            acceptanceReport = await AgencyHelper.API.requestAdminSignTechnicalAcceptance({
                                acceptanceId: row?.acceptanceId,
                                hsmPasscode: hsmPassword,
                            });
                        } else {
                            acceptanceReport = await AgencyHelper.API.requestAdminSignFinancialAcceptance({
                                acceptanceId: row?.acceptanceId,
                                hsmPasscode: hsmPassword,
                            });
                        }
                    } else {
                        acceptanceReport = await AgencyHelper.API.requestAgencySignAcceptance({
                            acceptanceId: row?.acceptanceId,
                            hsmPasscode: hsmPassword,
                        });
                    }
                    if (acceptanceReport && _.isObject(acceptanceReport)) {
                        ToastHelper.showSuccess('Ký biên bản thành công');
                        if (onRefresh) {
                            onRefresh();
                        }
                    } else {
                        ToastHelper.showError(acceptanceReport || 'Ký biên bản thất bại');
                    }
                }}
            />,
            'md',
            false,
            true
        );
    };

    const createSignAction = (row) => ({
        text: 'Ký biên bản',
        iconElement: <i className="fa-regular fa-file-signature" style={{ fontSize: '1.1rem' }} />,
        click: () => handleSignAcceptance(row),
    });

    const buildMoreActionsAcceptance = (row) => {
        const actions = [];
        actions.push({
            text: 'Xem chi tiết',
            iconElement: <i className="fa-regular fa-eye" style={{ fontSize: '1.1rem' }} />,
            click: () => {
                if (Utils.isValid(row?.document)) {
                    Utils.openInNewTab(Utils.getFullUrl(row?.document));
                }
            },
        });

        switch (row?.status) {
            case AgencyConstants.AcceptanceStatus.CREATED:
                if (isAdminMaintainer) {
                    actions.push(createSignAction(row));
                }
                if (isAdminMain || isAdminMaintainer) {
                    actions.push(createEditTechnicalAction(row), createCancelAction(row), createDeleteAction(row));
                }
                break;

            case AgencyConstants.AcceptanceStatus.ADMIN_SIGNED:
                if (isAgency) actions.push(createSignAction(row));
                if (isAdminMain) actions.push(createCancelAction(row));
                break;

            case AgencyConstants.AcceptanceStatus.COMPLETED:
                if (isAdminMain) actions.push(createCancelAction(row));
                break;

            case AgencyConstants.AcceptanceStatus.CANCELLED:
                if (isAdminMain) actions.push(createDeleteAction(row));
                break;

            default:
                break;
        }

        return actions;
    };

    const handleSetDialogSize = (documentType) => {
        const size = documentType === AgencyConstants.AcceptanceType.PAPER ? 'md' : 'xl';
        setDialogSize(size);

        setTimeout(() => {
            handleCreateTechnicalAcceptanceReport(size);
        }, 0);
    };

    const handleCreateTechnicalAcceptanceReport = (size = dialogSize) => {
        return AppCustomDialogHelper.show(
            '',
            <AgencySaleCreateTechnicalAcceptanceView
                title="Tạo biên bản nghiệm thu kỹ thuật"
                chargeStationDetail={chargeStationDetail}
                contentEl={
                    <>
                        Bạn muốn tạo biên bản nghiệm thu kỹ thuật cho trạm sạc:{' '}
                        <span
                            style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
                        >
                            {chargeStationDetail?.name}
                        </span>
                        ?
                    </>
                }
                onSetDialogSize={handleSetDialogSize}
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
                onConfirm={async (param) => {
                    setCreatingAcceptanceReport(true);
                    try {
                        let acceptanceReportParam = param;
                        if (param?.documentType === AgencyConstants.AcceptanceType.PAPER) {
                            acceptanceReportParam = _.omit(acceptanceReportParam, ['attachedFiles']);
                        }

                        const acceptanceReport =
                            await AgencyHelper.API.requestCreateAcceptanceReport(acceptanceReportParam);

                        if (acceptanceReport && _.isObject(acceptanceReport)) {
                            ToastHelper.showSuccess('Tạo biên bản nghiệm thu thành công');
                            AppCustomDialogHelper.hide();
                            if (onRefresh) {
                                onRefresh();
                            }
                        } else {
                            ToastHelper.showError(acceptanceReport || 'Tạo biên bản nghiệm thu thất bại');
                        }
                    } catch (e) {
                        ToastHelper.showError('Có lỗi xảy ra khi tạo biên bản nghiệm thu');
                    } finally {
                        setCreatingAcceptanceReport(false);
                    }
                }}
            />,
            size,
            false,
            true
        );
    };

    return (
        <div>
            {UIHelper.buildCard(
                <div className="pb-4">
                    {/* header */}
                    <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-column">
                            <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
                                Danh sách biên bản nghiệm thu
                            </span>
                            <span style={UIHelper.buildFontStyle('600', '13px', AppColors.gray[800])}>
                                Tổng:{' '}
                                <span style={UIHelper.buildFontStyle('600', '13px', AppColors.primary)}>
                                    {acceptanceReportList?.length} biên bản
                                </span>
                            </span>
                        </div>
                        <div>
                            {isAdmin && UIHelper.buildGreenButton(
                                'Tạo biên bản nghiệm thu kỹ thuật',
                                (!technicalAcceptance || technicalAcceptance?.status === AgencyConstants.AcceptanceStatus.CANCELLED)
                                    ? handleCreateTechnicalAcceptanceReport
                                    : null,
                                <i className="fa-regular fa-circle-plus" />
                            )}
                        </div>
                    </div>

                    {/* danh sach hop dong */}
                    <div className="px-4">
                        <KTTable
                            columns={acceptanceReportColumns}
                            items={acceptanceReportList}
                            selectableRows={false}
                            striped={false}
                            compactGrid={false}
                            onClickedRow={(row) => { }}
                            onSelectedRowsChanged={(rows) => { }}
                            onDoubleClickedRow={(row) => { }}
                            noDataComponent={
                                <EmptyView
                                    icon={null}
                                    title="Không có dữ liệu để hiển thị"
                                    text={<span>Hiện tại không có biên bản nghiệm thu nào cho đơn hàng này.</span>}
                                />
                            }
                        />
                    </div>
                </div>,
                false
            )}
        </div>
    )
}

export default ChargeStationAcceptanceListView;